export default __webpack_public_path__ + "static/ut-screen-android-mobile-34510357406c29aa85e96a0f4727f492.png";